import Accordion from "components/shared/accordion/Accordion";
import GuiContext from "config/context/guiContext";
import TableContext from "config/context/tableContext";
import ThemeContext from "config/context/themeContext";
import ToastContext from "config/context/toastContext";
import styles from "css/dashboard/dashboard.module.css";
// import { getInitialTableStructures } from "lib/getInitialTableStructures";
import { useContext, useState, useEffect } from "react";
import Button from "../shared/button/Button";
import Option from "../shared/select-and-option/Option";
import Select from "../shared/select-and-option/Select";
import AddNewAccount from "./AddNewAccount";
import AddNewServer from "./AddNewServer";
import { useUpdateDatabaseStructure } from "api/database/useDatabase";

export default function Dashboard() {
  const { dark } = useContext(ThemeContext);
  const { URL, userData, selectedAccount, selectedServer, selected } =
    useContext(GuiContext);
  const {
    emptyTable,
    setActiveComposition,
    setActiveComplexType,
    updateTableStructureContextData,
    updateComplexTypes,
  } = useContext(TableContext);
  const { updateDatabaseStructure, loading } = useUpdateDatabaseStructure();
  const { insertIntoToastList } = useContext(ToastContext);
  const [openAddAccountModal, setOpenAddAccountModal] = useState(false);
  const [openRemoveAccountModal, setOpenRemoveAccountModal] = useState(false);
  const [openAddServerModal, setOpenAddServerModal] = useState(false);
  const [openRemoveServerModal, setOpenRemoveServerModal] = useState(false);
  const [showSection, setShowSection] = useState({
    account: true,
    server: true,
  });

  const handleDeleteAccount = () => {
    if (userData.accounts.length <= 1) {
      insertIntoToastList(
        "You can't remove last account",
        "warning",
        "lastAccount",
      );
      return;
    }
    setOpenRemoveAccountModal(true);
  };

  const handleDeleteServer = () => {
    if (userData.servers.length <= 1) {
      insertIntoToastList(
        "You can't remove last server",
        "warning",
        "lastServer",
      );
      return;
    }
    setOpenRemoveServerModal(true);
  };

  const handleSelectedAccount = async (e) => {
    let myTableName = e.target.value;
    if (!myTableName) return;
    emptyTable();
    selectedAccount(myTableName);
  };

  // useEffect(() => {
  //   if (selected.selectedAccount) {
  //     updateDatabaseStructure();
  //   }
  // }, [selected.selectedAccount]);

  return (
    <section
      className={`${styles.dashboard} ${dark ? styles.dark : ""
        } column justify-start`}
    >
      <div className={styles.dashboard_header}>
        <h2>Dashboard</h2>
        <p>
          Welcome to your dashboard. Here's a quick overview of your databases
          and servers.
        </p>
      </div>
      <div id={styles.controlGroup}>
        <Accordion header={<h3>Databases</h3>} isOpen={true}>
          <p>
            <img src="./img/info.svg" alt="info" width="16" height="16" />
            &nbsp;
            <i>
              Manage your databases with ease. Click to access, add, or delete.
            </i>
          </p>
          <div className="container">
            <label htmlFor="accountSelect">Database Name</label>
            <Select
              value={selected.selectedAccount}
              onChange={handleSelectedAccount}
              className={styles.select}
              name="accountSelect"
              id="accountSelect"
            >
              {userData &&
                userData.accounts &&
                userData.accounts.map((account, i) => (
                  <Option key={account + i} value={account}>
                    {account}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="column align-center gap-05">
            <Button onClick={() => setOpenAddAccountModal(true)} expand="full">
              Add New Database
            </Button>
            <Button
              onClick={handleDeleteAccount}
              variant="danger"
              buttonType="text"
              expand="full"
              disabled={userData.accounts.length <= 1}
            >
              Delete Database
            </Button>
          </div>
        </Accordion>
        <Accordion header={<h3>Servers</h3>} isOpen={true}>
          <p>
            <span>
              <img src="./img/info.svg" alt="info" width="16" height="16" />
            </span>
            &nbsp;
            <i>Manage your servers below. Click to access, add, or delete.</i>
          </p>
          <div className="container">
            <label htmlFor="serverURL">Server URL</label>
            <Select
              value={selected.selectedServer}
              onChange={(e) => selectedServer(e.target.value)}
              className={styles.select}
              name="serverURL"
              id="serverURL"
            >
              {userData &&
                userData.servers &&
                userData?.servers.map((server, i) => (
                  <Option key={server + i} value={server}>
                    {server}
                  </Option>
                ))}
            </Select>
          </div>
          <div className="column align-center gap-05">
            <Button onClick={() => setOpenAddServerModal(true)} expand="full">
              Add New Server
            </Button>
            <Button
              onClick={handleDeleteServer}
              variant="danger"
              buttonType="text"
              expand="full"
              disabled={userData.servers.length <= 1}
            >
              Remove Server
            </Button>
          </div>
        </Accordion>
      </div>
      <AddNewAccount
        typeCall={"add_account"}
        setOpenModal={setOpenAddAccountModal}
        openModal={openAddAccountModal}
      />
      <AddNewAccount
        typeCall={"remove_account"}
        setOpenModal={setOpenRemoveAccountModal}
        openModal={openRemoveAccountModal}
      />
      <AddNewServer
        typeCall={"add_server"}
        setOpenModal={setOpenAddServerModal}
        openModal={openAddServerModal}
      />
      <AddNewServer
        typeCall={"remove_server"}
        setOpenModal={setOpenRemoveServerModal}
        openModal={openRemoveServerModal}
      />
    </section>
  );
}
